import { useState } from "react";
import { Copy, Check } from "lucide-react";

const copyText = async (text) => {
  try {
    await navigator.clipboard.writeText(text);
  } catch {
    const el = document.createElement("textarea");
    el.value = text;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    el.remove();
  }
};

export const CopyCodeButton = ({ code }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    await copyText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative inline-flex">
      <button
        type="button"
        onClick={handleCopy}
        className="group inline-flex items-center gap-3 px-6 py-2 bg-amber-400/20 border-2 border-amber-400 rounded-lg hover:bg-amber-400/30 hover:scale-105 active:scale-95 transition-transform"
        title="Cliquer pour copier"
        data-testid="propfirm-copy-code-button"
      >
        <span className="text-2xl font-bold text-amber-300 tracking-wider">{code}</span>
        {copied ? (
          <Check size={20} className="text-green-400" />
        ) : (
          <Copy size={20} className="text-amber-300/80 group-hover:text-amber-200" />
        )}
      </button>
      <span
        className={`absolute top-full mt-2 left-1/2 -translate-x-1/2 sm:mt-0 sm:left-full sm:ml-3 sm:top-1/2 sm:translate-x-0 sm:-translate-y-1/2 whitespace-nowrap px-3 py-1 rounded-md bg-green-500 text-black text-sm font-semibold shadow-lg pointer-events-none transition-opacity duration-300 ${
          copied ? "opacity-100" : "opacity-0"
        }`}
        data-testid="propfirm-code-copied-message"
      >
        Code copié
      </span>
    </div>
  );
};
